/**
 * Categorias de equipamento agora são cadastráveis (tabela `equipment_categories`).
 * Aqui ficam só os ícones disponíveis e utilitários de texto.
 */

/** Ícones que a tela de categorias oferece (o frontend mapeia cada chave para um desenho). */
export const EQUIPMENT_ICONS = [
  'smartphone',
  'laptop',
  'tablet',
  'monitor',
  'video-card',
  'gamepad',
  'watch',
  'headphones',
  'printer',
  'tv',
  'camera',
  'speaker',
  'cpu',
  'desktop',
  'all-in-one',
  'motherboard',
  'power-supply',
  'ups',
  'router',
  'wifi',
  'network-switch',
  'access-point',
  'modem',
  'projector',
  'ip-camera',
  'dvr',
  'mouse',
  'keyboard',
  'storage',
  'network-accessory',
  'usb',
  'memory',
  'webcam',
] as const;
export type EquipmentIcon = (typeof EQUIPMENT_ICONS)[number];

export const EQUIPMENT_ICON_LABELS: Record<EquipmentIcon, string> = {
  smartphone: 'Celular',
  laptop: 'Notebook',
  tablet: 'Tablet',
  monitor: 'Computador',
  'video-card': 'Placa de vídeo',
  gamepad: 'Console',
  watch: 'Relógio',
  headphones: 'Fone',
  printer: 'Impressora',
  tv: 'TV',
  camera: 'Câmera',
  speaker: 'Caixa de som',
  cpu: 'Outro',
  desktop: 'Desktop / gabinete',
  'all-in-one': 'All-in-One',
  motherboard: 'Placa-mãe',
  'power-supply': 'Fonte de alimentação',
  ups: 'Nobreak',
  router: 'Roteador',
  wifi: 'Wi-Fi / repetidor',
  'network-switch': 'Switch de rede',
  'access-point': 'Access Point',
  modem: 'Modem',
  projector: 'Projetor',
  'ip-camera': 'Câmera IP',
  dvr: 'DVR / gravador',
  mouse: 'Mouse',
  keyboard: 'Teclado',
  storage: 'HD / SSD',
  'network-accessory': 'Acessório de rede',
  usb: 'Dispositivo USB',
  memory: 'Memória',
  webcam: 'Webcam',
};

/** Compara nomes ignorando acentos e maiúsculas ("Celular" = "celular" = "CELULAR"). */
export function normalizeLabel(label: string | null | undefined): string {
  return String(label ?? '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .trim()
    .toLowerCase();
}

/**
 * Nome da categoria padrão para os valores antigos do protótipo / do enum anterior
 * (usado pela importação de dados). Categorias padrão são criadas pela migration.
 */
export const LEGACY_CATEGORY_NAMES: Record<string, string> = {
  celular: 'Celular',
  smartphone: 'Celular',
  notebook: 'Notebook',
  tablet: 'Tablet',
  desktop: 'Desktop',
  computador: 'Desktop',
  console: 'Console',
  outro: 'Outro eletrônico',
  'outro eletronico': 'Outro eletrônico',
};

export const FALLBACK_CATEGORY_NAME = 'Outro eletrônico';

export function legacyCategoryName(label: string | null | undefined): string {
  return LEGACY_CATEGORY_NAMES[normalizeLabel(label)] ?? FALLBACK_CATEGORY_NAME;
}

export function equipmentDisplayName(e: { brand?: string | null; model?: string | null }): string {
  return [e.brand, e.model].filter(Boolean).join(' ').trim() || 'Equipamento';
}
